import StatusBokadIcon from "@/assets/actionIcons/statusbokad.svg";
import StatusGenomfordIcon from "@/assets/actionIcons/statusgenomford.svg";
import StatusPagaendeIcon from "@/assets/actionIcons/statuspagaende.svg";
import StatusAnkommitIcon from "@/assets/actionIcons/statusankommit.svg";
import StatusUteblivenIcon from "@/assets/actionIcons/statusutebliven.svg";
import StatusAvbokadIcon from "@/assets/actionIcons/statusavbokad.svg";
import StatusStrukenIcon from "@/assets/actionIcons/statusstruken.svg";

export const besokIcons = {
    Bokad: StatusBokadIcon,
    Genomförd: StatusGenomfordIcon,
    Pågående: StatusPagaendeIcon,
    Ankommit: StatusAnkommitIcon,
    Utebliven: StatusUteblivenIcon,
    "Sen avbokning": StatusUteblivenIcon,
    Avbokad: StatusAvbokadIcon,
    Struken: StatusStrukenIcon,
};

export const STATUS_BESOK = {
    Bokad: { label: "Bokad", value: "Bokad", icon: "statusbokad" },
    Genomförd: { label: "Genomförd", value: "Genomförd", icon: "statusgenomford" },
    Pågående: { label: "Pågående", value: "Pågående", icon: "statuspagaende" },
    Ankommit: { label: "Ankommit", value: "Ankommit", icon: "statusankommit" },
    Avbokad: { label: "Avbokad", value: "Avbokad", icon: "statusavbokad" },
    Struken: { label: "Struken", value: "Struken", icon: "statusstruken" },
} as const;

export const AVVIKELSER = {
    Utebliven: { label: "Patient utebliven", value: "Patient utebliven", icon: "statusutebliven" },
    "Sen avbokning": { label: "Sen avbokning", value: "Sen avbokning", icon: "statusutebliven" },
};
